import { useState } from "react";
import Autocomplete from "react-google-autocomplete";

const Location = ({
  formInputFieldError,
  formInputType,
  pattern,
  submitted,
  handleLocation,
  allFieldsEmpty,
  isValidated
}) => {
  const [unfocused, setUnfocused] = useState(false);
  const handleUnfocused = (e) => { setUnfocused(true) }

  return (
    <div>
      <Autocomplete
        className="location-input"
        apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
        onPlaceSelected={(place) => {
          if (place) {
            handleLocation(place.address_components);
          }
        }}
        style={{ width: "100%", borderColor: isValidated }}
        type={formInputType}
        id="inputId"
        placeholder=""
        pattern={pattern}
        onBlur={handleUnfocused}
        focused={submitted ? null : unfocused.toString()}
      />
      <label className="special-label">Location<span className="asterisk">&nbsp;*</span></label>
      <span
        id="signup-error-message"
        className="text-danger mt-2 signup-error-message professional-signup-error-message"
      >
        {allFieldsEmpty ? null : formInputFieldError}
      </span>
    </div>
  );
};

export default Location;
